import cn from "clsx"
import styles from "./styles.module.scss"
import Link from "next/link"
import * as icons from "./assets"
import type { FC, HTMLAttributes } from "react"
import type { SocialLink as LinkProps } from "storyblok/schema"



interface SocialLinkProps
extends HTMLAttributes<HTMLAnchorElement>, LinkProps {}

export const SocialLink: FC<SocialLinkProps> = ({ className, type, link, ...rest }) => {
  const Icon = icons[type]
  return (
    <li className={cn(styles.item, className)}>
      <Link href={link}>
        <a {...rest} target="_blank" rel="me" itemProp="url">
          <Icon className={styles.icon} />
        </a>
      </Link>
    </li>
  )
}
